import React from "react";
import { Button, Group, Tooltip } from "@mantine/core";
import classes from "./FormComponents.module.css";

export interface SearchFormActionsProps {
  submitText?: string;
  newSearchText?: string;
  isStackMode?: boolean;
  isEditing?: boolean;
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  isStackFull?: boolean;
  onAddToStack?: () => void;
  onUpdateInStack?: () => void;
  onCancelEdit?: () => void;
  onNewSearch?: () => void;
  tooltipLabel?: string;
}

export const SearchFormActions: React.FC<SearchFormActionsProps> = ({
  submitText = "Search",
  newSearchText = "New Search",
  isStackMode = false,
  isEditing = false,
  disabled = false,
  loading = false,
  loadingText,
  isStackFull = false,
  onAddToStack,
  onUpdateInStack,
  onCancelEdit,
  onNewSearch,
  tooltipLabel = "Search for video clips",
}) => {
  return (
    <Group justify="center" mt="md" w="100%" p={10} pt={5} pb={0} gap="xs">
      {isEditing ? (
        <>
          {onCancelEdit && (
            <Button
              variant="subtle"
              color="gray"
              style={{ flex: 1, borderRadius: 15 }}
              size="sm"
              type="button"
              onClick={onCancelEdit}
            >
              Cancel
            </Button>
          )}
          <Button
            className={classes.button}
            style={{ flex: 2 }}
            size="sm"
            type={onUpdateInStack ? "button" : "submit"}
            onClick={onUpdateInStack}
            disabled={disabled || loading}
          >
            Update in Stack
          </Button>
        </>
      ) : isStackMode ? (
        <>
          {onNewSearch && (
            <Tooltip label="Clear stack and start a fresh search">
              <Button
                variant="default"
                style={{ flex: 1, borderRadius: 15 }}
                size="sm"
                type="button"
                onClick={onNewSearch}
                disabled={disabled || loading}
              >
                {newSearchText}
              </Button>
            </Tooltip>
          )}
          <Tooltip label="Maximum of 5 queries reached" disabled={!isStackFull}>
            <Button
              className={classes.button}
              style={{ flex: onNewSearch ? 1 : undefined }}
              w={onNewSearch ? undefined : "100%"}
              size="sm"
              type={onAddToStack ? "button" : "submit"}
              onClick={onAddToStack}
              disabled={disabled || loading || isStackFull}
            >
              + Add to Stack
            </Button>
          </Tooltip>
        </>
      ) : (
        <>
          {onAddToStack && (
            <Tooltip label="Maximum of 5 queries reached" disabled={!isStackFull}>
              <Button
                variant="default"
                style={{ flex: 1, borderRadius: 15 }}
                size="sm"
                type="button"
                onClick={onAddToStack}
                disabled={disabled || loading || isStackFull}
              >
                + Add to Stack
              </Button>
            </Tooltip>
          )}
          <Tooltip label={tooltipLabel}>
            <Button
              className={classes.button}
              style={{ flex: onAddToStack ? 1 : undefined }}
              w={onAddToStack ? undefined : "100%"}
              size="sm"
              type="submit"
              loading={loading}
              disabled={disabled || loading}
            >
              {loading && loadingText ? loadingText : submitText}
            </Button>
          </Tooltip>
        </>
      )}
    </Group>
  );
};

export default SearchFormActions;
